import React from 'react'
import classNames from 'classnames'
import loaderAssets from '@/styles/loader/Loader.json'
import styles from '@/styles/loader/Loader.module.scss'
import dynamic from 'next/dynamic';

const Player = dynamic(() => import('react-lottie'), { ssr: false });
const Loader = ({ isNavBar = false }) => {
  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center',
        isNavBar ? styles.categoriesContainer : styles.loaderContainer
      )}
    >
      <Player options={{loop:true, autoplay:true,animationData:loaderAssets}}  height= {130} width={150}>
  </Player>
    </div>
  )
}

export default Loader